import PropTypes from 'prop-types';
import React from 'react';
import { setRating } from '../../utils/star-rating';

const StarRating = props => {
  const selectedStars = setRating(props.therapistRating);
  const totalStars = props.maxRating;

  const firstMethod = () =>
    [...Array(totalStars)].map(
      (el, i) =>
        i < selectedStars ? (
          <i
            key={el}
            style={{ color: '#8dd1d8', fontSize: '1.4rem' }}
            className="fa fa-star"
          />
        ) : (
          <i
            key={el}
            style={{ color: '#8dd1d8', fontSize: '1.4rem' }}
            className="fa fa-star-o"
          />
        ),
    );

  const secondMethod = () =>
    [...Array(totalStars)].map(
      (el, i) =>
        // eslint-disable-next-line no-nested-ternary
        i < selectedStars && i + 1 > selectedStars ? (
          <i
            key={el}
            style={{ color: '#8dd1d8', fontSize: '1.4rem' }}
            className="fa fa-star-half-o"
          />
        ) : i < selectedStars ? (
          <i
            key={el}
            style={{ color: '#8dd1d8', fontSize: '1.4rem' }}
            className="fa fa-star"
          />
        ) : (
          <i
            key={el}
            style={{ color: '#8dd1d8', fontSize: '1.4rem' }}
            className="fa fa-star-o"
          />
        ),
    );

  return (
    <React.Fragment>
      {Number.isInteger(selectedStars) ? firstMethod() : secondMethod()}
    </React.Fragment>
  );
};

StarRating.propTypes = {
  therapistRating: PropTypes.number.isRequired,
  maxRating: PropTypes.number.isRequired,
};

export default StarRating;
